import styled from 'styled-components';
import { Button, Select } from 'next/components/ui';

export const SubClause = styled.div`
  align-items: center;
  display: flex;
  flex-grow: 1;
  justify-content: flex-start;

  > * {
    margin-right: 10px;

    :last-child {
      margin-right: 0;
    }
  }

  ${Select} {
    flex-basis: 100%;
    max-width: 100%;
    min-width: 160px;
  }

  ${Button} {
    align-self: stretch;
    flex-shrink: 0;
    width: 130px;
  }
`;
